import { useTranslation } from "react-i18next";
import { AlertTriangle, Coins, Ban } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";

export const BalanceCard = ({ wallet }) => {
  const { t } = useTranslation();
  const low = wallet.balance <= 0;
  const tone = wallet.blocked ? "text-destructive" : low ? "text-amber-500" : "text-primary";

  return (
    <NeuCard data-testid="wallet-balance-card" className="animate-rise-in">
      <div className="flex items-start justify-between gap-3">
        <p className="label-xs">{t("wallet.balance")}</p>
        <Coins className={`h-5 w-5 ${tone}`} />
      </div>
      <p className={`mt-3 font-mono text-4xl font-black ${tone}`} data-testid="wallet-balance-value">
        {wallet.balance}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">
        {t("wallet.graceLimit", { count: wallet.grace_limit })}
      </p>

      {wallet.blocked ? (
        <p
          data-testid="wallet-blocked-banner"
          className="mt-4 flex items-start gap-2 rounded-2xl bg-destructive/10 p-3 text-xs font-semibold text-destructive"
        >
          <Ban className="mt-0.5 h-4 w-4 shrink-0" />
          {t("wallet.blocked")}
        </p>
      ) : low ? (
        <p
          data-testid="wallet-low-banner"
          className="mt-4 flex items-start gap-2 rounded-2xl bg-amber-500/10 p-3 text-xs font-semibold text-amber-600"
        >
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
          {t("wallet.lowBalance")}
        </p>
      ) : null}
    </NeuCard>
  );
};
